<script lang="ts">
	import iconAwardStar from "@assets/icons/award_star.svg";
	import iconI from "@assets/icons/i.svg";
	import iconPublic from "@assets/icons/public.svg";
	import iconSchool from "@assets/icons/school.svg";
	import Formatted from "./common/Formatted.svelte";
	import Media from "./common/Media.svelte";
</script>

<div class="grid grid-cols-2 lg:grid-cols-4 mt-12 lg:mt-28 mb-8 lg:mb-20 gap-x-4 gap-y-8 lg:gap-y-10 lg:gap-0">
	<div class="flex flex-col items-center gap-4">
		<div class="w-16 h-16 md:w-20 md:h-20 bg-white rounded-full flex items-center justify-center">
			<Media class="max-lg:w-8" source={{ src: iconI, type: "image/svg+xml" }} width={29.75} height={40} alt="Icon"
			></Media>
		</div>
		<p class="text-blue max-w-36 md:max-w-52 font-semibold font-outfit text-center md:text-md">
			<Formatted text="Fungujeme na trhu clb[[už 23 let]]" />
		</p>
	</div>
	<div class="flex flex-col items-center gap-4">
		<div class="w-16 h-16 md:w-20 md:h-20 bg-white rounded-full flex items-center justify-center">
			<Media
				source={{ src: iconPublic, type: "image/svg+xml" }}
				class="max-lg:w-8"
				width={46.4}
				height={46.4}
				alt="Icon"
			></Media>
		</div>
		<p class="text-blue max-w-36 md:max-w-52 font-semibold font-outfit text-center md:text-md">
			<Formatted text="Jsme clb[[mezinárodní]] společnost" />
		</p>
	</div>
	<div class="flex flex-col items-center gap-4">
		<div class="w-16 h-16 md:w-20 md:h-20 bg-white rounded-full flex items-center justify-center">
			<Media
				class="max-lg:w-8"
				source={{ src: iconAwardStar, type: "image/svg+xml" }}
				width={50.8}
				height={50.73}
				alt="Icon"
			></Media>
		</div>
		<p class="text-blue max-w-36 md:max-w-52 font-semibold font-outfit text-center md:text-md">
			<Formatted text="Spolupracujeme clb[[s renomovanými výrobci]]" />
		</p>
	</div>
	<div class="flex flex-col items-center gap-4">
		<div class="w-16 h-16 md:w-20 md:h-20 bg-white rounded-full flex items-center justify-center">
			<Media class="max-lg:w-8" source={{ src: iconSchool, type: "image/svg+xml" }} width={44.27} height={36} alt="Icon"
			></Media>
		</div>
		<p class="text-blue max-w-36 md:max-w-48 font-semibold font-outfit text-center md:text-md">
			<Formatted text="Pořádáme clb[[workshopy a školení]]" />
		</p>
	</div>
</div>
